import * as React from 'react';
import { FONT_COLOR } from './CONSTANTS';
import Selector from './Selector';

const KeyConfigView = ({ octave, offset, changeOctave, changeOffset, root, changeRoot }) => {
	return (
		<div style={{ textAlign: 'center', height: '100%', height: '100%' }}>
			<div
				style={{
					width: '100%',
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-evenly',
				}}
			>
				<Selector label="PAN KB" value={offset} changeValue={changeOffset} />
				<Selector label="OCTAVE" value={octave} changeValue={changeOctave} />
				<Selector label="ROOT" value={root} changeValue={changeRoot} />
			</div>
		</div>
	);
};

export default KeyConfigView;
